export default "__VITE_ASSET__CqFgym7j__";